<template>
  <div class="hzc-forecast">
    <div>当前位置：<span style="cursor: pointer" @click="back(1)">{{ title }}</span> >
      <span style="cursor: pointer" @click="back(2)">大数据价格预测</span>
      > 正文
    </div>
    <DetailTitle :title="detailForm['titileTime'] + title + '价格预测'"></DetailTitle>
    <div class="banner">
      <div class="top">
        参考指标：{{ detailForm['name'] }}
      </div>
      <div class="bottom">
        <div class="left">
          <div class="zhangfu">
            <p>今日实际价格</p>
            <span>{{ detailForm['price'] }}</span>
            日涨跌
            <em v-if="Number(detailForm['floatPrice']) > 0" style="color:#D3131A">{{ '+' + detailForm['floatPrice'] }} <img
                src="../../../assets/home/shangsheng.png" alt=""></em>
            <em v-if="Number(detailForm['floatPrice']) < 0" style="color: #079F93">{{ detailForm['floatPrice'] }} <img
                src="../../../assets/home/xiajiang.png" alt=""></em>
            <em style="color: #999999" v-if="Number(detailForm['floatPrice']) === 0">{{ detailForm['floatPrice'] }} </em>
          </div>
          <div class="junjia">
            上月均价<span>{{ detailForm['lastMonthAvg'] }}</span>
            本月累计均价<span>{{ detailForm['nowMonthAvg'] }}</span>
          </div>
        </div>
        <div class="right">
          <p>价格未来趋势</p>
          <span style="color:#D3131A" v-if="detailForm['trendFlag'] === 1">涨<img
              src="../../../assets/home/shangsheng.png" alt=""></span>
          <span style="color: #079F93" v-if="detailForm['trendFlag'] === -1">跌<img
              src="../../../assets/home/xiajiang.png" alt=""></span>
          <span style="color: #999999" v-if="detailForm['trendFlag'] === 0">持平</span>
          <div>未来一个月价格趋势</div>
        </div>
        <div class="for">单位：{{ detailForm['unitName'] }}</div>
      </div>
    </div>
    <div class="content">
      <div id="myChartBig" style="width: 1100px;height:330px;cursor:pointer;padding:20px;"></div>
    </div>
    <div class="footer">
      <p>预测模型说明:</p>
      <p></p>
      <div v-html="detailForm.remark"></div>
    </div>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {coalForecastDetail} from '@/api'

export default {
  name: "Forecast",
  data() {
    return {
      title: '123',
      id: '',
      detailForm: {},
      optionBig: {
        grid: {
          left: "4%",
          right: "1%",
          bottom: "12%",
        },
        tooltip: {
          trigger: "axis",
        },
        dataZoom: [{
          type: 'slider',//图表下方的伸缩条
          zoomOnMouseWheel: true,
          show: true, //是否显示
          realtime: true, //拖动时，是否实时更新系列的视图
          start: 0, //伸缩条开始位置（1-100），可以随时更改
          end: 100, //伸缩条结束位置（1-100），可以随时更改
        },
          {
            type: 'inside',
            start: 0,
            end: 100
          },],
        xAxis: {
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
            },
          },
        },
        yAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
            },
          },
        },
        visualMap: {
          top: "top",
          left: "center",
          orient: "horizontal",
          textStyle: {
            color: "#000",
          },
          dimension: 0,
          pieces: [
            {
              gt: 0,
              lte: 22,
              color: "#73c0df",
              label: "真实值",
            },

            {
              gt: 22,
              color: "#ef6667",
              label: "预测值",
            },
          ],
          outOfRange: {
            color: "#000",
          },
        },
        series: {
          name: "lineAQI",
          type: "line",
          data: [],
        },
      },
      backUrl: ''
    }
  },
  created() {
    this.backUrl = this.$route.query['flag']
    this.title = this.$route.query['other']
    this.id = this.$route.query['id'];
    this.getDetail()
  },
  components: {
    DetailTitle
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      coalForecastDetail(this.id).then(res => {
        this.detailForm = res.data;
        this.optionBig.xAxis.data = res.data.dateList;
        this.optionBig.series.data = res.data.priceList
        this.optionBig.series.name = res.data.name
        this.optionBig.visualMap.pieces[0].lte = res.data.priceListSize-1
        this.optionBig.visualMap.pieces[0].label = res.data.name
        this.optionBig.visualMap.pieces[1].gt = res.data.dottedLineListSize +1
        this.optionBig.visualMap.pieces[1].label = res.data.name + '（预测）'
        this.drawChart()
      })
    },
    /**
     * 地图配置加载
     */
    drawChart() {
      let myChartBig = this.$echarts.init(document.getElementById("myChartBig"));
      // 使用刚指定的配置项和数据显示图表。
      myChartBig.setOption(this.optionBig);
    },
    /**
     * 回退
     */
    back(flag) {
      if (flag === 1) {
        this.$router.push({
          path: this.backUrl
        })
      } else {
        this.$router.push({
          path: `${this.backUrl}/twoPage/forecast`,
          query: {flag: JSON.stringify({url: this.backUrl, varieties: this.title})}
        })
      }
    },
  }
}
</script>

<style scoped lang="less">
.hzc-forecast {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 30px;

  .banner {
    width: 1200px;
    height: 197px;
    margin-top: 16px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    border-top: 6px solid #D3131A;

    .top {
      height: 52px;
      border-bottom: 1px solid #ccc;
      padding-left: 16px;
      line-height: 52px;
      color: #222;
      font-weight: 500;
    }

    .bottom {
      height: 114px;
      position: relative;
      padding: 30px 0 0 115px;

      .left {
        width: 50%;
        float: left;

        .zhangfu {
          p {
            height: 30px;
            font-size: 22px;
            display: inline-block;
            font-weight: 500;
            color: #222222;
            line-height: 30px;
            margin-right: 85px;
          }

          span {
            width: 58px;
            height: 33px;
            font-size: 24px;
            font-weight: 500;
            color: #D3131A;
            line-height: 33px;
            margin-right: 12px;
          }

          em {
            width: 23px;
            height: 20px;
            font-size: 14px;
            font-weight: 500;
            color: #D3131A;
            line-height: 20px;
            font-style: normal;

            img {
              width: 12px;
              height: 12px;
            }
          }
        }

        .junjia {
          margin-top: 15px;

          span {
            display: inline-block;
            margin-left: 16px;
          }

          span:nth-child(n+1) {
            margin-right: 110px;
          }
        }
      }

      .right {
        width: 50%;
        float: right;

        p {
          height: 30px;
          font-size: 22px;
          font-weight: 500;
          color: #222222;
          line-height: 30px;
          display: inline-block;
        }

        span {
          height: 33px;
          font-size: 24px;
          display: inline-block;
          font-weight: 500;
          color: #D3131A;
          line-height: 33px;
          margin-left: 85px;

          img {
            width: 20px;
          }
        }

        div {
          margin-top: 16px;
        }
      }

      .for {
        height: 17px;
        font-size: 12px;
        color: #777777;
        line-height: 17px;
        position: absolute;
        bottom: 20px;
        right: 24px;
      }
    }
  }

  .content {
    width: 1200px;
    height: 400px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    margin-top: 24px;
  }

  .footer {
    width: 1140px;
    background: #EEEEEE;
    padding: 30px;
    margin-top: 24px;

    p {
      width: 128px;
      height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #222222;
      line-height: 22px;
    }

    div {
      width: 100%;
      height: auto;
      font-size: 14px;
      font-weight: 400;
      color: #222222;
      line-height: 20px;
    }
  }
}
</style>
